import axios from '@/services/axios'

export default {
    hasDataset(search, source) {
        return axios.get("/aiagent/hasDataset", { params: search, cancelToken: source.token });
    },

    getServiceQuestion(search, source) {
        return axios.get("/aiagent/getServiceQuestion", { params: search, cancelToken: source.token });
    },

    callAiAgent_SaveExcel(params, source) {
        return axios.post("/aiagent/save-excel", params, { cancelToken: source.token, maxRedirects: 0, headers: { 'Content-Type': 'multipart/form-data' }});
        // return axios.post("http://localhost:9041/save-excel", params, { cancelToken: source.token, maxRedirects: 0, headers: { 'Content-Type': 'multipart/form-data' }}); // for local test
    },

    callAiAgent_FileExist(params, source) {
        return axios.post("/aiagent/file-exist", params, { cancelToken: source.token, maxRedirects: 0});
        // return axios.post("http://localhost:9041/file-exist", params, { cancelToken: source.token, maxRedirects: 0}); // for local test
    },

    // callAiAgent_MarketOverview(params, source) {
    //     return axios.post('/aiagent/market_overview', params, { cancelToken: source.token, maxRedirects: 0, });
    //     // return axios.post('http://localhost:9040/market_overview', params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
    // },

    // callAiAgent_MarketOverviewReport(params, source) {
    //     // return axios.post('/aiagent/market_overview_report', params, { cancelToken: source.token, maxRedirects: 0, });
    //     return axios.post('http://localhost:9040/market_overview_report', params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
    // },

    // callAiAgent_ShareofSearch(params, source) {
    //     return axios.post('/aiagent/share_of_search', params, { cancelToken: source.token, maxRedirects: 0, });
    //     // return axios.post('http://localhost:9040/share_of_search', params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
    // },

    // callAiAgent_SearchTag(params, source) {
    //     return axios.post('/aiagent/search_tag', params, { cancelToken: source.token, maxRedirects: 0, });
    //     // return axios.post('http://localhost:9040/search_tag', params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
    // },

    // callAiAgent_Insight(params, source) {
    //     return axios.post('/aiagent/insight', params, { cancelToken: source.token, maxRedirects: 0, });
    //     // return axios.post('http://localhost:9040/insight', params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
    // },

    callAiAgent_NewsSummary(params, source) {
        return axios.post('/aiagent/news_summary', params, { cancelToken: source.token, maxRedirects: 0, });
        // return axios.post('http://localhost:9040/news_summary', params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
    },

    callAiAgent_NewsFiltering(params, source) {
        return axios.post('/aiagent/news_filtering', params, { cancelToken: source.token, maxRedirects: 0, });
        // return axios.post('http://localhost:9040/news_filtering', params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
    },

    callAiAgent_Request(params, source) {
        return axios.post("/aiagent/ask", params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
        // return axios.post('http://localhost:9041/v2/ask', params, { cancelToken: source.token, maxRedirects: 0, }); // for local test
    }
}